import { Component, OnDestroy, OnInit } from '@angular/core';
import * as fromProcess from '../../store/process/process.reducer';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store';
import { Subject } from 'rxjs';
import { ApiState } from 'src/app/model/api-state.model';
import { ProcessService } from 'src/app/services/process.service';

@Component({
  selector: 'app-load-policy-messages',
  templateUrl: './load-policy-messages.component.html',
  styleUrls: ['./load-policy-messages.component.scss'],
})
export class LoadPolicyMessagesComponent implements OnInit, OnDestroy {
  loadedPolicyDataState$ = this.store.select(fromProcess.selectPolicyDataState);
  loadedPolicyDataParams$ = this.processService.loadPolicyDataParams$;
  loadedPolicyDataError$ = this.processService.loadPolicyDataError$;

  apiStates = ApiState;

  policyNumber!: string | undefined;
  leadId!: string | undefined;

  ngDestroy$ = new Subject<void>();

  constructor(private store: Store<AppState>, private processService: ProcessService) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.ngDestroy$.next();
    this.ngDestroy$.complete();
  }

  closeNotification() {
    this.processService.clearPolicyParamsAndErrors();
    this.store.dispatch(fromProcess.actions.usePolicyDataReset());
  }
}
